import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import CommunicationsModal from './CommunicationsModal'
import { io } from 'socket.io-client'
import { connect } from 'react-redux'

import { getStateValue } from '../store/selectors'

const GlobalCommunications = (props) => {
    const { 
        user, 
        client, 
        driver, 
        supplier, 
        
        closeCommunicationModal,

        communicationUsers, 
        active, 
    } = props

    const location = useLocation()
    const [open, setOpen] = useState(true)
    const [reloadKey, setReloadKey] = useState(0)
    const [previewCommunication, setPreviewCommunication] = useState([])

    let activeUser = null
    let role = null

    if (user && user.id) {
        activeUser = user
        role = 'user'
    } else if (client && client.id) {
        activeUser = client
        role = 'client'
    } else if (driver && driver.id) {
        activeUser = driver
        role = 'driver'
    } else if (supplier && supplier.id) {
        activeUser = supplier
        role = 'supplier'
    }

    const handleCheckCommunications = (hasCommunications) => {
        if (!hasCommunications) setOpen(false)
    }

    useEffect(() => {
        if(!!active && communicationUsers?.length >= 1){
            setOpen(true)
            setPreviewCommunication(communicationUsers)
        }
    }, [active, communicationUsers])

    useEffect(() => {
        setOpen(true)
    }, [location.pathname, reloadKey])

    useEffect(() => {
        const setupWebPush = async () => {
            if (!activeUser || !('serviceWorker' in navigator) || !('PushManager' in window)) return;
            
            try {
                const registration = await navigator.serviceWorker.register('/sw.js');
                const permission = await Notification.requestPermission();
                
                if (permission !== 'granted') return;
                
                let subscription = await registration.pushManager.getSubscription();
                
                if (!subscription) {
                    const PUBLIC_VAPID_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;
                    
                    const urlBase64ToUint8Array = (base64String) => {
                        const padding = '='.repeat((4 - base64String.length % 4) % 4);
                        const base64 = (base64String + padding)
                            .replace(/-/g, '+')
                            .replace(/_/g, '/');
                        const rawData = window.atob(base64);
                        const outputArray = new Uint8Array(rawData.length);
                        for (let i = 0; i < rawData.length; ++i) {
                            outputArray[i] = rawData.charCodeAt(i);
                        }
                        return outputArray;
                    };
                    
                    subscription = await registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY)
                    });
                }
                
                const url = process.env.REACT_APP_API_ENDPOINT || '';
                await fetch(`${url}/app/save_web_push_token`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'usertype': `${role}_id`,
                        ...((activeUser.token)? { 'Authorization': `Bearer ${activeUser.token}` } : {})
                    },
                    body: JSON.stringify({ subscription })
                });
            } catch(e) {
                console.error("Web Push setup error:", e);
            }
        };

        setupWebPush();
    }, [activeUser])

    useEffect(() => {
        if (!activeUser) return

        const sysCompanyId = activeUser.sys_company_id || activeUser.SysCompanyId || activeUser.sysCompanyId;
        if (!sysCompanyId) return

        const url = process.env.REACT_APP_API_ENDPOINT || '';
        const socket = io(url, {
            path: '/notification-socket',
            transports: ['websocket'],
            query: {
                type: role,
                id: activeUser.id,
                sys: sysCompanyId,
                component: 'navBar',
            },
        })

        socket.on('new-communication', () => {
            setReloadKey(prev => prev + 1)
        })

        return () => {
            socket.disconnect()
        }
    }, [activeUser, role])

    if (!activeUser) return null

    return (
        <CommunicationsModal
            open={open}
            onClose={() => {
                setOpen(false)
                setPreviewCommunication([])
                closeCommunicationModal()
            }}
            userId={activeUser.id}
            onCheckCommunications={handleCheckCommunications}
            role={role}
            reloadKey={reloadKey}
            key={`${location.pathname}-${activeUser.id}`}
            previewCommunication={previewCommunication}
        />
    )
}

const mapDispatchToProps = (dispatch) => ({
    closeCommunicationModal: () => dispatch({
        type: `SET_COMMUNICATION_USER`,
        payload: false,
    }),
})

const mapStateToProps = (state) => ({
  communicationUsers: getStateValue(state?.communication_users?.entities),
  active: state?.communication_users?.active,
})

export default connect(mapStateToProps, mapDispatchToProps)(GlobalCommunications)
